//@flow
export const ACCESS_TOKEN: string = "accessToken"
export const REFRESH_TOKEN: string = "refreshToken"
export const CURRENT_KIOSK_ID: string = "currentKioskID"



// WEBPACK FOOTER //
// ./src/Auth/constants.js